export default "__VITE_ASSET__CJ1w99QX__"